import React from "react";
import { BannerColorTheme, getBannerColorTheme } from "./Common";

type StatisticsCard = {
    prefix: string;
    number: number;
    suffix: string;
};

export interface BannerStatisticsProps {
    cards?: StatisticsCard[];
    colorTheme?: BannerColorTheme;
}

const BannerStatisticsCards = (props: BannerStatisticsProps) => {
    const {
        cards,
        colorTheme
    } = props;

    const {
        textColor
    } = getBannerColorTheme(colorTheme ?? BannerColorTheme.Default);

    return (
        <div 
            className="grid grid-cols-1 sm:grid-cols-2 gap-1 lg:px-4 md:w-160">
            {cards?.map((card, index) => 
                <div 
                    key={index}
                    className={"rounded-lg p-4 text-base uppercase font-bold text-brand-primary-90 bg-brand-primary-40 lg:p-6"}
                >
                    {card.prefix} 
                    <br/>
                    <span className={`text-4.5xl ${textColor}`}>{card.number}</span>
                    <br/>
                    {card.suffix} 
                </div>
            )}
        </div>
    );
};

export default BannerStatisticsCards;
